import React, { type FC } from 'react'
import styles from './StorePromotion.module.scss'
import { Tag, TagStyle } from '@/tools/ui'

interface Props {
  isPrime: boolean
  benefit: string
  description: string
}

export const StorePromotionTag: FC<Props> = ({ isPrime, benefit, description }) => {
  const tagStyle = isPrime ? TagStyle.loyalty : TagStyle.promotion
  const promotionLabel = `${benefit} ${description}`
  return (
    <div className={styles.promotion}>
      {description && <Tag label={promotionLabel} style={tagStyle} />}
    </div>
  )
}
